"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EServiceNames = exports.ELogLevel = void 0;
var ELogLevel;
(function (ELogLevel) {
    ELogLevel["DEBUG"] = "DEBUG";
    ELogLevel["INFO"] = "INFO";
    ELogLevel["WARN"] = "WARN";
    ELogLevel["ERROR"] = "ERROR";
})(ELogLevel || (exports.ELogLevel = ELogLevel = {}));
var EAnalyticsEvents;
(function (EAnalyticsEvents) {
    EAnalyticsEvents["LAUNCH_LOAD_TIME"] = "LAUNCH_LOAD_TIME";
    EAnalyticsEvents["TARGET_LOAD_TIME"] = "TARGET_LOAD_TIME";
})(EAnalyticsEvents || (EAnalyticsEvents = {}));
var EServiceNames;
(function (EServiceNames) {
    EServiceNames["LOCATION"] = "LOCATION";
    EServiceNames["C_HUB"] = "C_HUB";
    EServiceNames["CAPS"] = "CAPS";
    EServiceNames["ELOQUA"] = "ELOQUA";
    EServiceNames["RECAPTCHA"] = "RECAPTCHA";
    EServiceNames["ADOBE"] = "ADOBE";
    EServiceNames["NOT_SPECIFIED"] = "NOT_SPECIFIED";
})(EServiceNames || (exports.EServiceNames = EServiceNames = {}));
